import { useState, useEffect } from "react";
import { useGetVendorId } from "../../hooks/global/User";
import SingleReview from "./SingleReview";
import { useTranslation } from "react-i18next";
import { getVendor } from "../../fetchers/vendor";
import { getReviews } from "../../fetchers/reviews";
import InfiniteScroll from "react-infinite-scroller";
import smileIcon from "../../assets/img/icons/smile-high-ico.svg";
import mediumIcon from "../../assets/img/icons/smile-medium-ico.svg";
import lowIcon from "../../assets/img/icons/smile-low-ico.svg";
import withTexticon from "../../assets/img/icons/chat.svg";
import * as _ from "lodash";
import LoadingSpinner from "../global/LoadingSpinner";

function Reviews(props) {
  const { t, i18n } = useTranslation();
  const vendorId = useGetVendorId();
  const scores = props.scores;
  const withTextSize = props.withTextSize;
  const editable = props.editable;
  const elementDetailsVisible = props.elementDetailsVisible;
  const pageSize = props.pageSize;
  let searchReviewsQuery = props.searchReviewsQuery;
  let isLoading = props.isLoading;

  const [scoreGte, setScoreGte] = useState(0);
  const [scoreLte, setScoreLte] = useState(6);
  const [withText, setWithText] = useState("");
  const [reviews, setReviews] = useState([]);
  const [vendor, setVendor] = useState("");
  const [reviewStatus, setReviewStatus] = useState("APPROVED");
  const [reviewsFetched, setReviewsFetched] = useState(true);
  const [currentPage , setCurrentPage ] = useState(0);
  const [filter, setFilter] = useState({
    stars: undefined,
    onlyWithText: undefined,
  });

  

  const fourFiveStarsSize = _.parseInt(scores[4] || 0) + _.parseInt(scores[3] || 0);
  const threeStarsSize = _.parseInt(scores[2] || 0);
  const oneTwoStarsSize = _.parseInt(scores[1] || 0) + _.parseInt(scores[0] || 0);

  /// Add scores to queryparams
  searchReviewsQuery.reviewStatus = reviewStatus;
  searchReviewsQuery.pageSize = pageSize;
  searchReviewsQuery.scoreGte = scoreGte;
  searchReviewsQuery.scoreLte = scoreLte;
  searchReviewsQuery.withText = withText;

  useEffect(() => {
    getVendor(vendorId).then((vendors) => {
      setVendor(vendors);
    });
  }, [vendorId]);

  useEffect(() => {
    /*getReviews(vendorId, searchReviewsQuery).then((greviews) => {
      setReviews(greviews)
      setReviewsFetched(greviews.length >= pageSize);
    }
    );*/
    setReviews([]);
    setCurrentPage(0);
    searchReviews(0, searchReviewsQuery);
  }, [searchReviewsQuery, vendorId]);

  /// set styles for review icons and score limits for rendering
  const setStarsFilter = (e, filterString) => {
    e.preventDefault();
    let newFilter = filter;
    newFilter.stars = filter.stars === filterString ? undefined : filterString;
    setFilter(newFilter);
    setReviews((reviews.length = 0));
    setCurrentPage(0);
    searchReviews(0, searchReviewsQuery);
  };

  const toggleTextFilter = (e) => {
    e.preventDefault();
    let newFilter = filter;
    newFilter.onlyWithText = filter.onlyWithText ? undefined : true;
    setFilter(newFilter);
    setReviews((reviews.length = 0));
    setCurrentPage(0);
    searchReviews(0, searchReviewsQuery);
  };

  const searchReviews = (page = 0, searchReviewsQuery) => {
    
    let queryParams = searchReviewsQuery
      ? searchReviewsQuery
      : props.searchReviewsQuery;

    queryParams.scoreGte = scoreGte;
    queryParams.scoreLte = scoreLte;
    queryParams.withText = undefined;

    if (filter.onlyWithText) {
      queryParams.withText = true;
    }

    if (filter.stars) {
      switch (filter.stars) {
        case "top":
          queryParams.scoreGte = 3;
          break;
        case "mid":
          queryParams.scoreGte = 2;
          queryParams.scoreLte = 4;
          break;
        case "bottom":
          queryParams.scoreLte = 3;
          break;
        default:
          break; // Add default case
      }
    }

    queryParams.pageSize = pageSize;
    queryParams.page = page;
    queryParams.reviewStatus = reviewStatus;

    /*console.log("set", queryParams)*/

    getReviews(queryParams.vendorId, queryParams).then((greviews) => {


      let allReviews = page === 0 ? [...greviews]:[...reviews, ...greviews];
      setReviews(allReviews);
      setReviewsFetched(greviews.length >= pageSize);

    });
  };


  return (
    <section className="reviews">
      <div className="MainTileWrap">
      {isLoading && <div className="adminReportOverlay"><LoadingSpinner className="my-5" /></div>}
        <h3>{t("admin.common.custOpi")}</h3>
        <div className="sorting clearfix">
          <div
            className={
              "sort high " + (filter.stars === "top" ? "highActive" : "")
            }
          >
            <a href="#" onClick={(e) => setStarsFilter(e, "top")}>
              <img src={smileIcon} alt="" />
              <p className="hidden-sm hidden-xs">
                {fourFiveStarsSize}{" "}
                {t("admin.common.review", { count: fourFiveStarsSize })}
              </p>
              <p className="visible-sm-inline visible-xs-inline">
                {fourFiveStarsSize}
              </p>
            </a>
          </div>
          <div
            className={
              "sort medium " + (filter.stars === "mid" ? "mediumActive" : "")
            }
          >
            <a href="#" onClick={(e) => setStarsFilter(e, "mid")}>
              <img src={mediumIcon} alt=""/>
              <p className="hidden-sm hidden-xs">
                {threeStarsSize}{" "}
                {t("admin.common.review", { count: threeStarsSize })}
              </p>
              <p className="visible-sm-inline visible-xs-inline">
                {threeStarsSize}
              </p>
            </a>
          </div>
          <div
            className={
              "sort bottom " + (filter.stars === "bottom" ? "bottomActive" : "")
            }
          >
            <a href="#" onClick={(e) => setStarsFilter(e, "bottom")}>
              <img src={lowIcon} alt="" />
              <p className="hidden-sm hidden-xs">
                {oneTwoStarsSize}{" "}
                {t("admin.common.review", { count: oneTwoStarsSize })}
              </p>
              <p className="visible-sm-inline visible-xs-inline">
                {oneTwoStarsSize}
              </p>
            </a>
          </div>

          <div
            className={
              "sort textOnly " + (filter.onlyWithText ? "textOnlyActive" : "")
            }
          >
            <a href="#" onClick={(e) => toggleTextFilter(e)}>
              <img src={withTexticon} alt="" />
              <p className="hidden-sm hidden-xs">
                {withTextSize}{" "}
                {t("admin.common.review", { count: Math.round(withTextSize) })}{" "}
                {t("admin.common.withOpi")}
              </p>
              <p className="visible-sm-inline visible-xs-inline">
                {withTextSize}
              </p>
            </a>
          </div>
        </div>
        
        {reviews.length > 0 && (
          <InfiniteScroll
            pageStart={0}
            loadMore={() => {
              searchReviews(currentPage + 1);
              setCurrentPage(currentPage + 1);
            }}
            hasMore={reviewsFetched}
            initialLoad={false}
            loader={
              <div className="loaderReviews" key="loader">
                <div className="loader" key={0}></div>
              </div>
            }
            threshold={300}
          >
            {reviews.map((review) => {
              return (
                <SingleReview
                  key={review.user.id + Math.random()}
                  reviewId={review.id}
                  review={review}
                  editable={editable}
                  vendor={vendor}
                  elementDetailsVisible={elementDetailsVisible}
                  isHighlighted={false}
                />
              );
            })}
          </InfiniteScroll>
          
        )}
      </div>
    </section>
  );
}

export default Reviews;
